import { TColors } from '@cian/ui-kit/colors';

import { TLabelColor, ELabelColor } from '../../types/label';

export const labelBgColorMap: Record<ELabelColor, TColors> = {
  [ELabelColor.Red]: 'error_10',
  [ELabelColor.Green]: 'success_10',
  [ELabelColor.Blue]: 'primary_10',
  [ELabelColor.Gray]: 'gray10_100',
  [ELabelColor.DarkGray]: 'gray6_100',
  [ELabelColor.Yellow]: 'warning15_100',
  [ELabelColor.SimpleBlue]: 'primary_10',
};

export const labelTextColorMap: Record<ELabelColor, TColors> = {
  [ELabelColor.Red]: 'error_100',
  [ELabelColor.Green]: 'success_100',
  [ELabelColor.Blue]: 'primary_100',
  [ELabelColor.Gray]: 'black_100',
  [ELabelColor.DarkGray]: 'black_100',
  [ELabelColor.Yellow]: 'warning_100',
  [ELabelColor.SimpleBlue]: 'primary_100',
};

export function mapLabelBgColor(color: TLabelColor): string {
  return labelBgColorMap[color];
}

export function mapLabelColor(color: TLabelColor) {
  return labelTextColorMap[color] as TColors;
}
